import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface GlassConfirmConfig {
  icon?: string;
  iconColor?: 'primary' | 'danger' | 'success' | 'warning';
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmColor?: 'primary' | 'danger' | 'success' | 'warning';
}

export interface GlassConfirmResult {
  confirmed: boolean;
}

@Injectable({ providedIn: 'root' })
export class GlassConfirmService {

  private configSubject = new Subject<GlassConfirmConfig | null>();
  private resultSubject = new Subject<GlassConfirmResult>();

  config$ = this.configSubject.asObservable();
  result$ = this.resultSubject.asObservable();

  confirm(config: GlassConfirmConfig): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.configSubject.next(config);
      const sub = this.result$.subscribe(result => {
        sub.unsubscribe();
        this.configSubject.next(null);
        resolve(result.confirmed);
      });
    });
  }

  onConfirm(): void {
    this.resultSubject.next({ confirmed: true });
  }

  onCancel(): void {
    this.resultSubject.next({ confirmed: false });
  }
}
